import baseService from '../shared/baseService';

const stateService = (countryId: number) => baseService(`countries/${countryId}/states`);

export default {
    stateService
};

